module.exports = __webpack_public_path__ + "static/media/sss-auto-headset.7006d668.svg";